import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { QUERY_KEY_MAP } from 'src/constants';
import { getInstallerNotesPromise } from 'src/utils';

export const useGetInstallerNotes = () => {
  const { deviceId } = useParams<{ deviceId: string }>();

  const { data, isLoading, error, isError } = useQuery({
    queryKey: [QUERY_KEY_MAP.useGetInstallerNotes, deviceId],
    queryFn: () => getInstallerNotesPromise(deviceId || ''),
    enabled: !!deviceId,
  });

  return {
    data,
    isLoading,
    error,
    isError,
  };
};
